module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Overseas Agent Assignments")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    attrs: {
      "center": ""
    }
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "mr-3 mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export Overseas Assignment' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports(
          'OVERSEAS_SCREEN_ALL',
          '0',
          '1',
          '1',
          'Export Overseas Assignment'
        )
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export Overseas Assignment') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search (Assignment No. / Client / Container No. / Shipping BL No / SHipping Invoice No / MBL / HBL )"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "Select To"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.ToFilter),
      callback: function($$v) {
        _vm.ToFilter = $$v
      },
      expression: "ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Agent"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.agentFilter),
      callback: function($$v) {
        _vm.agentFilter = $$v
      },
      expression: "agentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Incoterm")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Incoterm"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.termFilter),
      callback: function($$v) {
        _vm.termFilter = $$v
      },
      expression: "termFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("BL FILTER")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blNoStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingFilter),
      callback: function($$v) {
        _vm.billingFilter = $$v
      },
      expression: "billingFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("CLOSE STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CLosedStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Close Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.closedFilter),
      callback: function($$v) {
        _vm.closedFilter = $$v
      },
      expression: "closedFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("MANIFESTATION STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ManifestationStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Manifestation"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.manifestationFilter),
      callback: function($$v) {
        _vm.manifestationFilter = $$v
      },
      expression: "manifestationFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("SOB FILTER")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.FFExport,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "isFFExportActive",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffExportFclSeries",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "text-left",
          style: (row11.item.seenExec == '0' ? 'color:black' : 'color:black')
        }, [_c('div', {
          staticClass: "showMoreData",
          style: (row11.item.seenExec == '0' ? 'color:black' : 'color:black'),
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) ?
                '' :
                _vm.viewExportFCLPage(row11.item)
            }
          }
        }, [_c('span', [_c('b', [_vm._v(_vm._s(row11.item.ffExportFclSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row11.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row11.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row11.item.raisedBy)), _c('br')]), _vm._v(" "), (row11.item.enquiry_booking_no) ? _c('span', [_vm._v("BRF No : " + _vm._s(row11.item.enquiry_booking_no)), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.inco_term) ? _c('span', [_vm._v("Inco Term : " + _vm._s(row11.item.inco_term)), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), ((row11.item.finalBillingCompleted == '1')) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row11.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row11.item.is_locked == '1' &&
              (row11.item.finalBillingCompleted == 1 ||
                row11.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row11.item.is_locked == '1' &&
                (row11.item.finalBillingCompleted == 1 ||
                  row11.item.locked_counter > 0) ?
                _vm.LockUnLock(row11.item, 'locked') :
                ''
            }
          }
        }, [(
          row11.item.is_locked == '1' &&
          (row11.item.finalBillingCompleted == 1 ||
            row11.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), (
          row11.item.sob_date_detected != '' &&
          row11.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_c('br'), _vm._v("SOB : " + _vm._s(row11.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e()], 1), _vm._v(" "), (row11.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row11.item.ffExportFclSeries,
            "PMC_JOBID": row11.item.allModuleId.toString(),
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row11.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row11.item.allModuleId,
            "jb_series": row11.item.ffExportFclSeries
          }
        }), _vm._v(" "), (row11.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row11.item.ffExportFclSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
          row11.item.toSplitAssignmentNo && row11.item.newContainerFlow == '1'
        ) ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row11.item.toSplitAssignmentNo))])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "newfreightContainers",
      fn: function(row5) {
        return [(row5.item.newContainerFlow == '1') ? _c('div', [(row5.item.newfreightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.newfreightContainers) ? _c('div', _vm._l((row5.item.newfreightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row5.item.newContainerFlow == '0') ? _c('div', [(row5.item.freightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.freightContainers) ? _c('div', _vm._l((row5.item.freightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "newShipperInv",
      fn: function(row56) {
        return [(row56.item.newContainerFlow == '1') ? _c('div', [(row56.item.newShipperInv) ? _c('div', {
          staticClass: "text-left"
        }, [(row56.item.newShipperInv) ? _c('div', _vm._l((row56.item.newShipperInv.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row56.item.newContainerFlow == '0') ? _c('div', [(row56.item.shipperInvNo) ? _c('div', {
          staticClass: "text-left"
        }, [(row56.item.shipperInvNo) ? _c('div', _vm._l((row56.item.shipperInvNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "newSB",
      fn: function(row564) {
        return [(row564.item.newContainerFlow == '1') ? _c('div', [(row564.item.newSB) ? _c('div', {
          staticClass: "text-left"
        }, [(row564.item.newSB) ? _c('div', _vm._l((row564.item.newSB.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e(), _vm._v(" "), (row564.item.newContainerFlow == '0') ? _c('div', [(row564.item.shippingBillNo) ? _c('div', {
          staticClass: "text-left"
        }, [(row564.item.shippingBillNo) ? _c('div', _vm._l((row564.item.shippingBillNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                        ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _vm._e()]
      }
    }, {
      key: "POR",
      fn: function(row10) {
        return [_c('span', [_vm._v("Stuffing :-\n                " + _vm._s(row10.item.stuffingType == "warehouseStuffing" ?
          "WAREHOUSE" :
          "FACTORY")), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  Agent Name : " + _vm._s(row10.item.agentName) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("S-Line :- " + _vm._s(row10.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR :- " + _vm._s(row10.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("LP :- " + _vm._s(row10.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD :- " + _vm._s(row10.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD :- " + _vm._s(row10.item.FPOD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Booking No. :- " + _vm._s(row10.item.validBookingNo))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "MBL",
      fn: function(row18) {
        return [_c('span', [_vm._v("MBL NO.:- " + _vm._s(row18.item.master_linerBLNumber)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HBL NO.:- " + _vm._s(row18.item.house_BLNumber)), _c('br')]), _vm._v(" "), (row18.item.newfreightContainers) ? _c('span', [_c('b', [_vm._v("CONT NO.:-")]), _vm._v(" " + _vm._s(_vm.wordWrap(row18.item.newfreightContainers, 24))), _c('br')]) : _vm._e(), _vm._v(" "), (row18.item.containersTypes) ? _c('span', [_c('b', [_vm._v("CONT TYPE.:-")]), _vm._v(" " + _vm._s(_vm.wordWrap(row18.item.containersTypes, 24)))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "action",
      fn: function(row3) {
        return [(row3.item.debitcount >= 1) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(2, row3.item) :
                ''
            }
          }
        }, [_vm._v("Debit Note")]) : _vm._e(), _vm._v(" "), (row3.item.debitcount <= 0) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(2, row3.item) :
                ''
            }
          }
        }, [_vm._v("Debit Note")]) : _vm._e(), _vm._v(" "), (row3.item.creditcount >= 1) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(1, row3.item) :
                ''
            }
          }
        }, [_vm._v("Credit Note")]) : _vm._e(), _vm._v(" "), (row3.item.creditcount <= 0) ? _c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "disabled": row3.item.closedOverseas_status == 0 ? true : false,
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              row3.item.CountmainManifestationData > 0 ?
                _vm.openNoteModal(1, row3.item) :
                ''
            }
          }
        }, [_vm._v("Credit Note")]) : _vm._e(), _vm._v(" "), (!row3.item.preAlertDate) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("Send Pre-Alert")]) : _c('div', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("PreAlert sent on " + _vm._s(row3.item.preAlertDate) + " ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("by " + _vm._s(row3.item.preAlertRaisedBy) + " ")])])], 1), _vm._v(" "), (
          row3.item.frghtTermsMbl == 'Collect' &&
          row3.item.frghtTermsHbl == 'Collect' &&
          row3.item.closedOverseas_status == 1 &&
          row3.item.creditDebitNoteType != 1 &&
          row3.item.creditDebitNoteType != '' &&
          !_vm.checkcreditDebitNote_Status(row3.item.NoteDetails)
        ) ? _c('b-button', {
          attrs: {
            "variant": "warning",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("Credit Note Pending\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _vm._l((row3.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(
            CDitem.uploadCreditDebit != '' &&
            CDitem.approvalStatus == '1' &&
            CDitem.creditDebitNoteType == '1'
          ) ? _c('b-badge', {
            staticClass: "p-2 ml-2",
            attrs: {
              "variant": "warning",
              "creditNoteStatus": CDitem.creditDebitNote_Status,
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(row3.item.ffExportFclSeries, CDitem.uploadCreditDebit)
              }
            }
          }, [(CDitem.creditDebitNoteType == '1') ? _c('span', [_vm._v("Credit Note PDF")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
            CDitem.uploadCreditDebit != '' &&
            CDitem.approvalStatus == '1' &&
            CDitem.creditDebitNoteType == '2'
          ) ? _c('b-badge', {
            staticClass: "p-2",
            attrs: {
              "variant": "warning",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(row3.item.ffExportFclSeries, CDitem.uploadCreditDebit)
              }
            }
          }, [(CDitem.creditDebitNoteType == '2') ? _c('span', [_vm._v("Debit Note ")]) : _vm._e(), _vm._v("PDF"), _c('br')]) : _vm._e()], 1)
        }), _vm._v(" "), _c('b-badge', {
          staticClass: "p-2 mt-1",
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("Debit / Credit Generated on " + _vm._s(row3.item.creditDebitTime))]), _vm._v(" "), _c('br')])], 2), _vm._v(" "), _c('br'), _vm._v(" "), (row3.item.portLocationType == 'USA' && !row3.item.amsTime) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("AMS Filed")]) : (row3.item.portLocationType == 'USA' && row3.item.amsTime) ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("AMS on " + _vm._s(row3.item.amsTime) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.portLocationType == 'USA' && !row3.item.isfTime) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.checkActions(row3.item)
            }
          }
        }, [_vm._v("ISF Filed")]) : (row3.item.portLocationType == 'USA' && row3.item.amsTime) ? _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("ISF on " + _vm._s(row3.item.isfTime) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "eta_details",
      fn: function(row321) {
        return [(row321.item.ETA_destination_estimated != '') ? _c('span', [_vm._v("Tentative : " + _vm._s(row321.item.ETA_destination_estimated))]) : _vm._e(), _vm._v(" "), (row321.item.ETA_destination_actual != '') ? _c('span', [_c('br'), _vm._v("Actual : " + _vm._s(row321.item.ETA_destination_actual))]) : _vm._e()]
      }
    }, {
      key: "manifestation",
      fn: function(row3) {
        return [(row3.item.CountmainManifestationData <= 0) ? _c('span', [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          }
        }, [_vm._v("Pending")])], 1) : (row3.item.CountmainManifestationData > 0) ? _c('span', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.sendMANIFESTATION(row3.item)
            }
          }
        }, [_vm._v("Received")])], 1) : _vm._e(), _vm._v(" "), (row3.item.newManiFestCount > 0) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("New Manifestation " + _vm._s(row3.item.newManiFestCount))]), _c('br')]) : _vm._e()]
      }
    }, {
      key: "closed",
      fn: function(row3) {
        return [(row3.item.closedOverseas_status == 1) ? _c('span', [_c('b-button', {
          staticClass: "mb-1",
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openCloseOverseasModal(row3.item)
            }
          }
        }, [_vm._v("Close")])], 1) : (row3.item.closedOverseas_status == 0) ? _c('span', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          }
        }, [_vm._v("Closed")]), _c('br'), _vm._v("\n                User:" + _vm._s(row3.item.closedOverseas_byuser)), _c('br'), _vm._v("\n                Date:" + _vm._s(row3.item.closedOverseas_created_at) + "\n              ")], 1) : _vm._e(), _vm._v(" "), _vm._l((row3.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(
            _vm.$sessionsStorage.get('designation') == 'Admin' &&
            _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
            CDitem.noteSeries
          ) ? _c('EditCRDRNote', {
            attrs: {
              "title": 'Edit ' +
                (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                ' Note : ' +
                CDitem.noteSeries,
              "note_id": CDitem.note_id,
              "noteSeries": CDitem.noteSeries,
              "note_page": CDitem.page,
              "AgentType": CDitem.agentType,
              "creditDebitNoteType": CDitem.creditDebitNoteType,
              "approvalStatus": CDitem.approvalStatus,
              "uploadCreditDebit": CDitem.uploadCreditDebit,
              "creditDebitNote_Status": CDitem.creditDebitNote_Status,
              "JOBID": row3.item.allModuleId,
              "JOBNO": row3.item.ffExportFclSeries,
              "JOBDATE": row3.item.loginTime,
              "JOBTYPE": row3.item.jobType
            }
          }) : _vm._e()], 1)
        }), _vm._v(" "), (row3.item.closedOverseas_status == '0') ? _c('CommonOverseaUnLock', {
          attrs: {
            "title": 'Open Overseas FCL Assignment',
            "Overlock_item": row3.item,
            "Overlock_JOBNO": row3.item.ffExportFclSeries,
            "Overlock_allModuleId": row3.item.allModuleId,
            "Overlock_table_name": 'frght_ffexportfcl',
            "Overlock_table_key": 'ffExportFclId',
            "Overlock_table_value": row3.item.ffExportFclId,
            "Overlock_column_key": 'closedOverseas_status',
            "Overlock_column_value": row3.item.closedOverseas_status,
            "Overlock_module_type": 'Overseas FCL Freight Forwarding'
          }
        }) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row3.item.allModuleId,
            "fk_client_id": row3.item.clientId,
            "fk_pod_id": row3.item.PODLocationId
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirmModal",
    attrs: {
      "id": "modal-multi-3",
      "hide-footer": "",
      "title": "Confirmation"
    }
  }, [_c('p', {
    staticClass: "my-1"
  }, [_vm._v("\n        " + _vm._s(_vm.mergeModal.actionType == "2" ?
    "Are you sure you want to Split this Assignment..!" :
    "Are you sure you want to Merge containers of this Assignment to selected Assignment..!") + "\n      ")]), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogConfirm
    }
  }, [_vm._v("Cancel & Close")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.isLoading == true ? true : false,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.onCloseSubmit
    }
  }, [_vm._v("Yes")])], 1)]), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "splitMergePop",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "scrollable": "",
      "id": "myDIV",
      "hide-footer": "",
      "title": _vm.mergeModal.actionType == '2' ?
        'Assignment Split Utility' :
        'Assignment Merge Utility'
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Action")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.actionList,
      "id": "actionType",
      "option-value": "aV",
      "option-text": "aT",
      "placeholder": "Select Action "
    },
    on: {
      "input": _vm.getSplitAssignment
    },
    model: {
      value: (_vm.mergeModal.actionType),
      callback: function($$v) {
        _vm.$set(_vm.mergeModal, "actionType", $$v)
      },
      expression: "mergeModal.actionType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.mergeModal.actionType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mergeModal.actionType == '1' ?
        _vm.toMergeAssignmentList :
        _vm.dummySplitAssignment,
      "id": "clientId",
      "option-value": "ffExportFclId",
      "option-text": "ffExportFclSeries",
      "placeholder": "Select Assignment "
    },
    on: {
      "input": _vm.getTomergeExecId
    },
    model: {
      value: (_vm.mergeModal.ffExportFclIdContainer),
      callback: function($$v) {
        _vm.$set(_vm.mergeModal, "ffExportFclIdContainer", $$v)
      },
      expression: "mergeModal.ffExportFclIdContainer"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.mergeModal.actionType == '1') ? _c('div', {
    staticClass: "gutr",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter1),
      callback: function($$v) {
        _vm.filter1 = $$v
      },
      expression: "filter1"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter1
    },
    on: {
      "click": function($event) {
        _vm.filter1 = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "",
      "bordered": "",
      "show-empty": "",
      "stacked": "md",
      "items": _vm.toMergeAssignmentList,
      "fields": _vm.fields1,
      "current-page": _vm.currentPage1,
      "per-page": _vm.perPage1,
      "filter": _vm.filter1,
      "sort-by": _vm.sortBy1,
      "sort-desc": _vm.sortDesc1,
      "sort-direction": _vm.sortDirection1
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy1 = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc1 = $event
      },
      "filtered": _vm.onFiltered1
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage1 - 1) * _vm.perPage1))])]
      }
    }, {
      key: "loginTime",
      fn: function(row1) {
        return [_c('b-form-radio', {
          attrs: {
            "disabled": _vm.containerList.length > 0 ? true : false,
            "name": "some-radios",
            "value": row1.item.ffExportFclId
          },
          on: {
            "change": function($event) {
              _vm.onRadioMerge(row1.item.ffExportFclId)
            }
          },
          model: {
            value: (_vm.mergeModal.ffExportFclIdContainer),
            callback: function($$v) {
              _vm.$set(_vm.mergeModal, "ffExportFclIdContainer", $$v)
            },
            expression: "mergeModal.ffExportFclIdContainer"
          }
        }, [_vm._v("Select")])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows1,
      "per-page": _vm.perPage1
    },
    model: {
      value: (_vm.currentPage1),
      callback: function($$v) {
        _vm.currentPage1 = $$v
      },
      expression: "currentPage1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.FFExportContainers.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "po"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Net Weight")]), _vm._v(" "), _c('th', [_vm._v("Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Select")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FFExportContainers), function(item1, index) {
    return _c('tr', {
      key: index,
      style: (item1.seenExec == '0' ? 'color:red' : 'color:black')
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Container No. :")]), _vm._v(" "), _c('span', {
      staticClass: "mainClick"
    }, [_vm._v(_vm._s(item1.containerNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Container Type :")]), _vm._v(" "), _c('span', {
      staticClass: "mainClick"
    }, [_vm._v(_vm._s(item1.containerType))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.netWeight) + _vm._s(item1.weightUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.grossWeight) + _vm._s(item1.weightUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.LineSealNo))]), _vm._v(" "), _c('td', [_c('md-checkbox', {
      staticClass: "md-primary",
      class: _vm.mergeFclContainers.indexOf(item1.ffExportFclId) >= 0 ?
        'md-checked checkedNew' +
        item1.ffExportFclId +
        (index + 1) :
        'checkedNew' + item1.ffExportFclId + (index + 1),
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "disabled": _vm.mergeModal.actionType == '1' &&
          _vm.mergeModal.ffExportFclIdContainer == '' ?
          true :
          false,
        "md-value": item1.ffExportFclId,
        "name": 'deptMas' + (item1.ffExportFclId + 1),
        "id": 'deptMas' + (item1.ffExportFclId + 1)
      },
      on: {
        "change": function($event) {
          _vm.getMergeContainerData(item1, index)
        }
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "pull-right ml-2",
    attrs: {
      "disabled": _vm.containerList.length <= 0 ||
        (_vm.FFExportContainers.length <= 1 && _vm.mergeModal.actionType == '2'),
      "variant": "primary"
    },
    on: {
      "click": _vm.mergeSubmit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeMerge
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e()], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "CloseOverseas-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "md",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v("Are you sure to want close")])]), _vm._v(" "), _c('center', [_c('span', {
    staticClass: "center"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.SaveCloseOverseas
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideCloseOverseasModal
    }
  }, [_vm._v("No")])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.noteModal.creditDebitNoteType == '1' ?
        'CREDIT NOTE - ' + _vm.noteModal.ffExportFclSeries :
        'DEBIT NOTE - ' + _vm.noteModal.ffExportFclSeries
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.noteModal.approvalStatus == "1" ?
    "Approved" :
    _vm.noteModal.sentForApproval == "1" ?
    "Sent for approval" :
    "") + "\n        ")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "cols": "11"
    }
  }, [(_vm.noteModal.uploadCreditDebit != '' && _vm.noteModal.approvalStatus == '1') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.noteModal.uploadCreditDebit)
      }
    }
  }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("Add Particulars "), _c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12 text-center"
    }
  }, [(_vm.noteModal.creditcount >= 1 && _vm.noteModal.creditDebitNoteType == '1') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Credit Note No. : ")]), _vm._v(_vm._s(_vm.noteModal.creditnoteSeriesDetailsCount))]) : _vm._e(), _vm._v(" "), (_vm.noteModal.debitcount >= 1 && _vm.noteModal.creditDebitNoteType == '2') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("DEBIT Note No. : ")]), _vm._v(_vm._s(_vm.noteModal.debitnoteSeriesDetailsCount))]) : _vm._e()])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentTypeList,
      "option-value": "TypeVal",
      "option-text": "TypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getAgentConsigneeList(_vm.noteModal.agentType)
      }
    },
    model: {
      value: (_vm.noteModal.agentType),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentType", $$v)
      },
      expression: "noteModal.agentType"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAllAgentColoaderList,
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": _vm.noteModal.agentType == 'Consignee' ?
        'Select Consignee' :
        'Select Agent/Coloader'
    },
    on: {
      "input": _vm.getConsigneeAgentDetails
    },
    model: {
      value: (_vm.noteModal.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "AgentColoader", $$v)
      },
      expression: "noteModal.AgentColoader"
    }
  }), _vm._v(" "), (!_vm.noteModal.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.AgentColoader))]) : _vm._e()], 1), _vm._v(" "), (_vm.noteModal.agentType == 'Consignee') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Consignee Address"
    }
  }, [_vm._v("\n            Consignee Address\n            "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Consignee Address"
    },
    model: {
      value: (_vm.noteModal.agentconsigneeAddress),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentconsigneeAddress", $$v)
      },
      expression: "noteModal.agentconsigneeAddress"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentconsigneeAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentconsigneeAddress))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.noteModal.agentType == 'Agent') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Agent Country"
    }
  }, [_vm._v("\n            Agent Country\n            "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Agent Country"
    },
    model: {
      value: (_vm.noteModal.agent_country),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agent_country", $$v)
      },
      expression: "noteModal.agent_country"
    }
  }), _vm._v(" "), (!_vm.noteModal.agent_country) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agent_country))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Vessel/Voy"
    }
  }, [_vm._v("\n            Vessel/Voy\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Vessel Voy"
    },
    model: {
      value: (_vm.noteModal.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "vesselVoy", $$v)
      },
      expression: "noteModal.vesselVoy"
    }
  }), _vm._v(" "), (!_vm.noteModal.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.vesselVoy))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "HBL/AWB"
    }
  }, [_vm._v("\n            HBL/AWB\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter HBL/AWB"
    },
    model: {
      value: (_vm.noteModal.house_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "house_bl_no", $$v)
      },
      expression: "noteModal.house_bl_no"
    }
  }), _vm._v(" "), (!_vm.noteModal.house_bl_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.house_bl_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "MBL/MAWB"
    }
  }, [_vm._v("\n            MBL/MAWB\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter MBL/MAWB"
    },
    model: {
      value: (_vm.noteModal.master_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "master_bl_no", $$v)
      },
      expression: "noteModal.master_bl_no"
    }
  }), _vm._v(" "), (!_vm.noteModal.master_bl_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.master_bl_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER"
    }
  }, [_vm._v("\n            SHIPPER\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER"
    },
    model: {
      value: (_vm.noteModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "clientName", $$v)
      },
      expression: "noteModal.clientName"
    }
  }), _vm._v(" "), (!_vm.noteModal.clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.clientName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "CONSIGNEE"
    }
  }, [_vm._v("\n            CONSIGNEE\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter CONSIGNEE"
    },
    model: {
      value: (_vm.noteModal.consignee),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "consignee", $$v)
      },
      expression: "noteModal.consignee"
    }
  }), _vm._v(" "), (!_vm.noteModal.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.consignee))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Destination"
    }
  }, [_vm._v("\n            Destination\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Destination"
    },
    model: {
      value: (_vm.noteModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "FPOD", $$v)
      },
      expression: "noteModal.FPOD"
    }
  }), _vm._v(" "), (!_vm.noteModal.FPOD) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.FPOD))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container No"
    }
  }, [_vm._v("\n            Container No.\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container No"
    },
    model: {
      value: (_vm.noteModal.containerNoArryNote),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containerNoArryNote", $$v)
      },
      expression: "noteModal.containerNoArryNote"
    }
  }), _vm._v(" "), (!_vm.noteModal.containerNoArryNote) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containerNoArryNote))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container Type"
    }
  }, [_vm._v("\n            Container Type\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container Type."
    },
    model: {
      value: (_vm.noteModal.containersTypes),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containersTypes", $$v)
      },
      expression: "noteModal.containersTypes"
    }
  }), _vm._v(" "), (!_vm.noteModal.containersTypes) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containersTypes))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER INV."
    }
  }, [_vm._v("\n            SHIPPER INV.\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER INV. Details"
    },
    model: {
      value: (_vm.noteModal.ShipperInvDet),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ShipperInvDet", $$v)
      },
      expression: "noteModal.ShipperInvDet"
    }
  }), _vm._v(" "), (!_vm.noteModal.ShipperInvDet) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ShipperInvDet))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Booking No"
    }
  }, [_vm._v("\n            Booking No\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.noteModal.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "validBookingNo", $$v)
      },
      expression: "noteModal.validBookingNo"
    }
  }), _vm._v(" "), (!_vm.noteModal.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.validBookingNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SOB"
    }
  }, [_vm._v("\n            SOB\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "SOB",
      "minute-step": 1,
      "name": "SOB"
    },
    model: {
      value: (_vm.noteModal.SOB),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "SOB", $$v)
      },
      expression: "noteModal.SOB"
    }
  }), _vm._v(" "), (!_vm.noteModal.SOB) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.SOB))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ETADest"
    }
  }, [_vm._v("\n            ETA Dest\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "ETADest",
      "minute-step": 1,
      "name": "ETADest"
    },
    model: {
      value: (_vm.noteModal.ETADest),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ETADest", $$v)
      },
      expression: "noteModal.ETADest"
    }
  }), _vm._v(" "), (!_vm.noteModal.ETADest) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ETADest))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "3"
    },
    model: {
      value: (_vm.noteModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "remarks", $$v)
      },
      expression: "noteModal.remarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.noteParticulars.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Selected Cont")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currecny")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Actions")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.noteParticulars), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Particular"
      },
      model: {
        value: (item.parti),
        callback: function($$v) {
          _vm.$set(item, "parti", $$v)
        },
        expression: "item.parti"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Quantity"
      },
      on: {
        "input": _vm.TotalAMT
      },
      model: {
        value: (item.qty),
        callback: function($$v) {
          _vm.$set(item, "qty", $$v)
        },
        expression: "item.qty"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Amount"
      },
      on: {
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (item.amt),
        callback: function($$v) {
          _vm.$set(item, "amt", $$v)
        },
        expression: "item.amt"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.final_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.container_selected))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.CurrencyList,
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParti(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), _vm._v(" "), (_vm.TotAMT != 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.noteParticulars.length > 0 && _vm.noteModal.AgentColoader) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.IsCDNotedisabled,
      "variant": "success"
    },
    on: {
      "click": _vm.submitNote
    }
  }, [_vm._v("Send for approval")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopSubmit",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseSubmit
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-888575dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/overSeasFreight.vue
// module id = 2794
// module chunks = 0